import { createSelector } from 'reselect';
import getSelectedBackground from './getSelectedBackground';

const isBackgroundUploading = createSelector([getSelectedBackground], (background) =>
    background ? background.uploading : false,
);

export default isBackgroundUploading;
